var React = require('react');

function SomeRss (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.17188 11.1338V8C17.6998 8 25.4308 15.7183 25.4308 25.2306H22.2918C22.2918 17.4458 15.9694 11.1338 8.17188 11.1338ZM8.17188 17.4015V14.2677C14.2391 14.2677 19.1528 19.1733 19.1528 25.2306H16.0138C16.0138 20.9118 12.4977 17.4015 8.17188 17.4015ZM13.0079 22.8164C13.0079 24.1496 11.9253 25.2304 10.5899 25.2304C9.25446 25.2304 8.17188 24.1496 8.17188 22.8164C8.17188 21.4832 9.25446 20.4023 10.5899 20.4023C11.9253 20.4023 13.0079 21.4832 13.0079 22.8164Z","fill":"white"}));
}

SomeRss.defaultProps = {"width":"33","height":"32","viewBox":"0 0 33 32","fill":"none"};

module.exports = SomeRss;

SomeRss.default = SomeRss;
